export const Z_INDEX = {
  base: 0,
  shelfShadow: 0, // Behind cards
  cards: 1, // Publications cards
  header: 50, // Fixed headers
  drawerOverlay: 99, // Drawer backdrop (below drawer)
  drawer: 100, // Drawer sidebar
  drawerButton: 150, // Drawer open/close buttons
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;
